import React from 'react'
import './reservation.css'
import From from '../../composents/form/From'

export default function Reservation() {
  return (
    <>
      <div className='container'>
      <From/>
      </div>
    </>
  )
}
